import React, { useState } from 'react';
import { Button } from '@carbon/react';
import { ChartRelationship } from '@carbon/react/icons';
import AliasClusterGraph from './alias-cluster-graph';
import { useAliasCluster } from './use-alias-cluster';

interface Props {
  // The row's display entity — the graph is fetched and centered on it.
  entityId: number;
}

// A "View alias graph" link for one row of the consolidation-risk override modal.
// The modal only lists names; the graph is where the user understands the full
// alias landscape (which member carries the flag, how the family connects). Lazily
// fetches the cluster on click. Self-contained so the shared modal stays agnostic
// of the reconcile pages.
const RowAliasGraphLink: React.FC<Props> = ({ entityId }) => {
  const [open, setOpen] = useState(false);
  const { members, edges, fetchCluster } = useAliasCluster(entityId);

  return (
    <>
      <Button
        kind="ghost"
        size="sm"
        renderIcon={ChartRelationship}
        onClick={() => {
          void fetchCluster();
          setOpen(true);
        }}
      >
        View alias graph
      </Button>
      <AliasClusterGraph
        open={open}
        onClose={() => setOpen(false)}
        selectedEntityId={String(entityId)}
        members={members}
        edges={edges}
      />
    </>
  );
};

export default RowAliasGraphLink;
